import { api } from './Api';

export const getRestaurants = async ({ signal } = {}) => {
  const response = await api.get('/restmanager/restaurants', undefined, { signal, noAutoRetry: true });
  if (!Array.isArray(response)) throw new Error('Invalid restaurant discovery response.');
  return response;
};

export const getTemplate = async () => {
  const response = await api.get('/localareamng/restaurant/template');
  return response;
};

export const getBusiness = async () => {
  const response = await api.get('/localareamng/business/all');
  return response;
};

export const getRestaurantList = async ({ page }) => {
  const response = await api.get('/localareamng/restaurant/all', { page });
  return response;
};
